$(function () {
    if ($('.footer').length > 0) {

        // if ($('.qrcode-box').length > 0) {
        //     var url = $('.qrcode-box').data('url');
        //     console.log(url);
        //     var qrcode = new QRCode('qrcode', {
        //         text: url,
        //         width: 106,
        //         height: 106,
        //         colorDark: '#000',
        //         colorLight: '#fff',
        //         // eslint-disable-next-line no-undef
        //         correctLevel: QRCode.CorrectLevel.H
        //     })

        // }


    }
});